/** Emails allowed to perform one-off, rarely-needed league admin actions (e.g. adding a division to a
 * season that is already running). Frontend gate only: it hides the affordance, the RPCs still
 * authorize by community role.
 *
 * `VITE_SUPER_ADMIN_EMAILS` (comma-separated) extends the list per environment -- the e2e web server
 * uses it so the test organizer can exercise the gated flow without a real super-admin login. */
export const SUPER_ADMIN_EMAILS = ["jurgis.kruglikovs@gmail.com"];

const envEmails = (): string[] =>
  String(import.meta.env?.VITE_SUPER_ADMIN_EMAILS ?? "")
    .split(",")
    .map((e) => e.trim().toLowerCase())
    .filter(Boolean);

export const isSuperAdmin = (email: string | null | undefined): boolean => {
  if (!email) return false;
  const normalised = email.trim().toLowerCase();
  return SUPER_ADMIN_EMAILS.includes(normalised) || envEmails().includes(normalised);
};
